import {
  ConfirmationPreferenceTypes,
  NotificationSettings,
  UserInfoType,
  UserMarketingPreference,
} from '@finxone-platform/shared/sys-config-types';

export class GetProfile {
  static readonly type = '[Profile] GetProfile';
  constructor(public emitUserProfileFetched = true) {}
}
export class SetProfile {
  static readonly type = '[Profile] SetProfile';
  constructor(public payload: UserInfoType, public shouldMergeWithState = true) {}
}

export class SetActiveRole {
  static readonly type = '[Profile] SetActiveRole';
  constructor(public role: string) {}
}

export class SetActiveOrgId {
  static readonly type = '[Profile] SetActiveOrgId';
  constructor(public organisationId: string) {}
}

export class NotificationSettingsUpdate {
  static readonly type = '[Profile] NotificationSettingsUpdate';
  constructor(public payload: NotificationSettings) {}
}

export class AvailableConfirmationMethodsUpdate {
  static readonly type = '[Profile] AvailableConfirmationMethodsUpdate';
  constructor(public payload: ConfirmationPreferenceTypes[]) {}
}

export class UserProfileUpdated {
  static readonly type = '[Profile] UserProfileUpdated';
}

export class UserProfileUpdateFailed {
  static readonly type = '[Profile] UserProfileUpdateFailed';
}

export class UserProfileFetched {
  static readonly type = '[Profile] UserProfileFetched';
}

export class SetActiveThemeForUser {
  static readonly type = '[Profile] SetActiveThemeForUser';
  constructor(public themeName: string) {}
}

export class UpdateUserMarketingPreferencesInProfileState {
  static readonly type = '[Profile] UpdateUserMarketingPreferencesInProfileState';
  constructor(public marketingPreferences: UserMarketingPreference) {}
}
